export const itr4Status = [
  "Individual",
  "HUF",
  "Firm (other than LLP)",
];

export const indianStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal"
];

export const itr4NatureOfEmployment = [
  "Central Govt.",
  "State Govt.",
  "Public Sector Undertaking",
  "Pensioners-CG",
  "Pensioners-SG",
  "Pensioners-PSU",
  "Pensioners- Others",
  "Others",
  "Not Annlicable (e.g. Family Pension etc.)",
];

export const itr4FiledUSlashS = [
  "139(1)-On or before due date",
  "139(4)-After due date",
  "139(5)-Revised Return",
  "119(2)(b)-After Condonation of delay"
];

export const itr4OrFiledInResponseToNoticeUSlashS = [
  "139(9)",
  "142(1)",
  "148",
  "153C"
];

export const itr4Question1 = [
  "Yes",
  "No",
  "Not applicable (Return was filed in ITR Form 1/ Form 2)"
];

